export default "__VITE_ASSET__504a80f8__"